import React from 'react';

type ButtonGroupProps = {
    className?: string;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ className, children}): JSX.Element =>
    <div className={['grid-buttons', 'container', className].join(' ')}>
        <div className="row justify-content-between bottom-container-min-width">
            { children }
        </div>
    </div>

export default ButtonGroup;
